import request from "../utils/request"

//我的提问上传
export function uploadImagester(datas) {
    return request({
        url: "/system/work/",
        method: 'post',
        data: datas,
        headers: {
            "authorization": "Bearer " + window.localStorage.getItem("user")
        }
    })
}

//心理视界详情
export function listvideo(id) {
    return request({
        url: "/system/articles/",
        params: id,
        method: "get"
    })
}


//心零之窗详情
export function solddealect(id) {
    return request({
        url: `system/articles/byId?id=${id}`,
        method: 'get',
    })
}

//查看聊天记录
export function historyChatMess(data) {
    return request({
        url: `/system/chatrecord/chatList`,
        method: "get",
        params: {
            data
        }
    })

}

// 查询留言详情
export function leavingInfo(query) {
    return request({
        url: '/system/message/listSon',
        method: 'get',
        params: query,
        headers: {
            "authorization": "Bearer " + window.localStorage.getItem("user")
        }
    })
}


// 手机端判断是否完善信息
export function phonePerfect(data) {
    return request({
        url: '/system/user/phonePerfect',
        method: 'post',
        params: data
    })
}



// 查询建议记录
export function listDiagnosis(query) {
    return request({
        url: '/system/diagnosis/listByPhone',
        method: 'get',
        params: query
    })
}



// 查询测试总分列表
export function listScore(query) {
    return request({
        url: '/system/score/list',
        method: 'get',
        params: query
    })
}



// 修改用户信息
export function phoneEdit(data) {
    return request({
        url: '/system/user/phoneEdit',
        method: 'post',
        data: data
    })
}
// 上传照片
export function uploadImager(data) {
    return request({
        url: '/system/public/uploadImage',
        method: 'post',
        data: data
    })
}

//获取用户信息
export function getUserInfo(query) {
    return request({
        url: '/system/api/index/getUserInfo',
        method: 'get',
        params: query
    })
}

// 登录时查询部门下拉树结构
export function treeselectAll(userId) {
    return request({
        url: '/system/dept/treeSelectAllByPhone',
        method: 'get',
        params: userId
    })
}


// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
        url: '/system/dict/data/type/' + dictType,
        method: 'get'
    })
}

//聊天发送图片

export function uploadImages(file) {
    return request({
        url: "/system/aliyun/uploadImage",
        method: "post",
        data: file
    })
}
//表情包
export function emjoin() {
    return request({
        url: "/system/emoji/list",
        method: 'get'
    })
}


//心灵美文
export function addlistmei(id) {
    return request({
        url: `/system/articles/${id}`,
        method: "get"
    })
}
//心理咨询详情
export function getDetails(id) {
    return request({
        url: `/system/roster/getDoctorById?userId=${id}`,
        method: "get"
    })
}

//查询咨询师列表
export function listDoctor(query) {
    return request({
        url: '/system/user/selectDoctorList',
        method: 'get',
        params: query
    })
}

// 查询站点坐标列表
export function listCoordinates(query) {
    return request({
        url: '/system/coordinates/list',
        method: 'get',
        params: query
    })
}

// 查询站点坐标详细
export function getCoordinates(id) {
    return request({
        url: '/system/coordinates/' + id,
        method: 'get'
    })
}


//点击tap
export function ppUserid(id) {
    return request({
        url: `/system/roster/getDoctorIdByType?consultantType=${id}`,
        method: "get"
    })
}

//心理咨询头部tap

export function tapList() {
    return request({
        url: "system/doctorType/list",
        method: "get"
    })
}
// 查询问题列表
export function listProblem(query) {
    return request({
        url: '/system/problem/listProblem',
        method: 'get',
        params: query
    })
}
// 查询问题详情
export function answerInfo(problemId) {
    return request({
      url: '/system/problem/answerInfo/' + problemId,
      method: 'get'
    })
}
// 新增留言咨询
export function addProblem(data) {
    return request({
        url: '/system/message',
        method: 'post',
        data: data,
        headers: {
            "authorization": "Bearer " + window.localStorage.getItem("user")
        }
    })
}

// 上传照片
export function uploadImage(data) {
    return request({
        url: '/system/public/uploadImage',
        method: 'post',
        data: data
    })
}

//大家再问
export function getdajiaList(data) {
    return request({
        url: "/system/problem/selectAllMessage",
        method: "get",
        params: data
    })
}


//心理咨询

export function getList(data) {
    return request({
        url: "/system/roster/typesettingConsultant",
        method: "post",
        data: data
    })
}

//音乐列表

export function typefastSong(id) {
    return request({
        url: `/system/soul/getContentByType?type=${id}`,
        method: "get"
    })
}

//心灵驿站
export function homslist() {
    return request({
        url: "/system/posthouse/selectSoulType",
        method: "get"
    })
}

//提交测评
export function addScaleActivity(data) {
    return request({
        url: '/system/ScoreDetail/addScaleActivity',
        method: 'post',
        data
    })
}

// 查询得分明细列表
export function listDetail(query) {
    return request({
        url: '/system/ScoreDetail/listMarge',
        method: 'get',
        params: query
    })
}
// 查询登录用户下所属医师
export function listDoctors() {
    return request({
        url: '/system/user/selectDoctor',
        method: 'get',
    })
}
// 查询排班列表
export function listRoster(query) {
    return request({
        url: '/system/roster/list',
        method: 'get',
        params: query
    })
}

// 新增咨询
export function addConsult(data) {
    return request({
        url: '/system/consult',
        method: 'post',
        data: data
    })
}

// 新增得分明细
export function addDetail(data) {
    return request({
        url: '/system/ScoreDetail',
        method: 'post',
        data: data
    })
}


export function listId(query) {
    return request({
        url: '/system/sub/list/subList',
        method: 'get',
        params: query
    })
}



//专业测试

export function ceList(list) {
    return request({
        url: '/system/main/list',
        method: "get",
        params: list
    })
}

//心灵之窗
export function chuanglist(data) {
    return request({
        url: "/system/articles/list",
        method: "get",
        data: data
    })
}

//轮播图

export function bannerList(data) {
    return request({
        url: "/system/carousel/list",
        method: "get",
        params: data
    })
}

//服务动态
export function Donglist(data) {
    return request({
        url: "/psychologicalService/activityNews/listPhone",
        method: "get",
        params: data
    })
}

//心灵境界
export function lovelist(data) {
    return request({
        url: "/system/articles/list",
        method: "get",
        params: data
    })
}

// 获取音视频房间号
export function getUuid(data){
    return request({
        url:"/system/chatrecord/getUuid",
        method:"get",
        params:data
    })
}

// 打电话记录
export function addPhoneRecord(data) {
    return request({
        url: '/system/history',
        method: 'post',
        data: data
    })
}